<template>
  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitPrepaymentRequestData">
      <div class="card-body">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">{{ $t('Settlement Date') }}</label><span class="text-danger"> *</span>
            <base-date-picker
              v-model="formData.promised_payment_date"
              :calendar-button="true"
              calendar-button-icon="calendar"
              @change="$v.formData.promised_payment_date.$touch()"
            />
            <div v-if="$v.formData.promised_payment_date.$error">
              <span v-if="!$v.formData.promised_payment_date.required" class="text-danger">{{ $t('validation.required') }}</span>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <base-button
            :outline="true"
            class="mr-3"
            color="theme"
            type="button"
            @click="closeBulkProcessModal"
          >
            {{ $t('general.cancel') }}
          </base-button>
          <base-button
            :loading="isLoading"
            icon="save"
            color="theme"
            type="submit"
            class="collapse-button"
          >
            {{ $t('prepayments.save_prepayment') }}
          </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import moment from 'moment'

const { required } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      formData: {
        promised_payment_date: null
      },
      isLoading: false
    }
  },
  validations () {
    return {
      formData: {
        promised_payment_date: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters('invoice', ['selectedInvoices']),
    ...mapGetters('modal', ['modalData'])
  },
  mounted () {
    this.setPromisedPaymentDate()
  },
  methods: {
    setPromisedPaymentDate () {
      const currentDate = moment().local().format('YYYY-MM-DD')
      this.formData.promised_payment_date = currentDate
    },
    ...mapActions('modal', ['closeModal', 'resetModalData', 'setIsSearching']),
    ...mapActions('invoice', ['bulkProcessPrePaymentInvoices']),

    async submitPrepaymentRequestData () {
  this.$v.formData.$touch()
  if (this.$v.$invalid) {
    return
  }

  this.isLoading = true

  const batchSize = 3 // Process 3 invoices at a time
  const invoices = [...this.selectedInvoices] // Clone the array
  const totalBatches = Math.ceil(invoices.length / batchSize)

  try {
    for (let i = 0; i < totalBatches; i++) {
      const batchIds = invoices.slice(i * batchSize, (i + 1) * batchSize)

      const data = {
        promised_payment_date: this.formData.promised_payment_date,
        ids: batchIds,
        type: 'Prepaid'
      }

      const res = await this.bulkProcessPrePaymentInvoices(data)
      console.log(`Batch ${i + 1} Response:`, res)

      if (!res.data.success) {
        window.toastr['error'](res.data.error || this.$t('Something went wrong in batch processing'))
        break
      }
    }

    this.closeBulkProcessModal()
    window.toastr['success'](this.$t('prepayments.bulk_settlement_success_message'))

    setTimeout(() => {
      location.reload()
    }, 1000)

  } catch (err) {
    console.error('Error during bulk settlement:', err)
    window.toastr['error'](this.$t('An unexpected error occurred during bulk settlement'))
    this.closeBulkProcessModal()
  } finally {
    this.isLoading = false
  }
},

    resetFormData () {
      this.formData = {
        promised_payment_date: null
      }
      this.$v.formData.$reset()
    },
    closeBulkProcessModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    }
  }
}
</script>

<style scoped>
.table-component {
  min-height: 0px;
}
</style>
